import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecarrentalserviceinpune() {



  const cardData =
  {
    keyword: 'Corporate Car Rental Services in Pune',
    heading: 'Sanavi Travels: Corporate Car Rental Services in Pune',
    headingDescription: 'Sanavi Travels offers professional Corporate Car Rental Services in Pune, providing reliable, safe, and comfortable transportation solutions for corporate clients, business executives, MNCs, and organizations. Our fleet of premium sedans, SUVs, and luxury cars is well-maintained and driven by experienced, uniformed, and background-verified chauffeurs, ensuring punctuality and a high standard of service. With customized corporate travel plans, daily and monthly rentals, airport transfers, employee transportation, transparent billing, and 24/7 dedicated support, Sanavi Travels guarantees smooth and efficient business travel operations. We provide corporate car rental services across Pune including Hinjewadi, Baner, Wakad, Kharadi, Viman Nagar, Hadapsar, Magarpatta, Pimpri-Chinchwad, and Pune Railway Station, making us a trusted partner for professional corporate mobility. Choose Sanavi Travels for dependable corporate car rental solutions in Pune, delivering comfort, reliability, and seamless business travel experiences.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the seat of Peshwa administration, it features massive stone walls, grand gates like the Delhi Darwaza, and spacious courtyards. Although partially destroyed by fire, its remains reflect Maratha valor and heritage. The evening light-and-sound show brings Pune’s glorious past to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant monument linked to India’s freedom movement. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi, set amidst serene gardens."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol is adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations and cultural events."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort near Pune, famous for the heroic sacrifice of Tanaji Malusare. Visitors can trek or drive up to the fort to enjoy breathtaking views of the Sahyadri ranges. The fort is popular for trekking, history exploration, and traditional Maharashtrian food."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars and a peaceful sanctum. Despite being in a busy area, the temple offers a calm spiritual experience."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts showcasing India’s cultural heritage. The collection includes musical instruments, sculptures, utensils, and ornaments. The recreated Mastani Mahal is a major highlight for visitors."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city after climbing 103 stone steps. The Parvati Temple complex, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati and is especially popular during sunrise and sunset."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from across the globe. It offers meditation programs, wellness therapies, and tranquil gardens, making it a center for peace, relaxation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. With bridges, water streams, and manicured lawns, it is ideal for morning walks, family outings, photography, and peaceful relaxation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure destination near Pune, especially during the monsoon season. The scenic reservoir, surrounding hills, and cool breeze make it a favorite spot for evening outings and weekend picnics. It also serves as the gateway to Sinhagad Fort."
  }
]
,




  "services": [
    {
      "name": "Corporate Car Rental Services in Pune",
      "description": "Corporate Car Rental Services in Pune provides reliable and professional transportation solutions for businesses and corporate travelers. With well-maintained, air-conditioned vehicles and experienced chauffeurs, this service ensures punctuality, comfort, and smooth travel for meetings, conferences, and daily corporate commutes."
    },
    {
      "name": "Corporate Cab Hire Pune",
      "description": "Corporate Cab Hire Pune offers flexible and efficient cab solutions tailored to corporate travel needs. Designed for executives, employees, and business guests, the service ensures timely pickups, comfortable rides, and dependable chauffeur-driven travel across Pune and nearby locations."
    },
    {
      "name": "AC Corporate Cab Pune",
      "description": "AC Corporate Cab Pune ensures a comfortable and relaxing travel experience with fully air-conditioned vehicles. Ideal for daily office commutes, client visits, and business travel, this service focuses on comfort, cleanliness, and professional driving standards."
    },
    {
      "name": "Luxury Corporate Car Pune",
      "description": "Luxury Corporate Car Pune delivers a premium travel experience with high-end vehicles, elegant interiors, and superior comfort. Perfect for senior executives, VIP clients, and corporate events, this service emphasizes style, punctuality, and professionalism."
    },
    {
      "name": "Office Transport Cab Pune",
      "description": "Office Transport Cab Pune provides organized and reliable transportation for daily office commutes. With trained drivers and well-maintained vehicles, the service ensures employee safety, punctual arrivals, and efficient route management."
    },
    {
      "name": "Employee Transport Cab Pune",
      "description": "Employee Transport Cab Pune is designed to support safe and convenient daily transportation for employees. Air-conditioned vehicles, professional chauffeurs, and scheduled pickups make this service ideal for corporate workforce mobility."
    },
    {
      "name": "Corporate Event Cab Pune",
      "description": "Corporate Event Cab Pune offers seamless transportation solutions for conferences, seminars, exhibitions, and corporate gatherings. The service ensures coordinated travel, timely arrivals, and comfortable rides for attendees and corporate guests."
    },
    {
      "name": "Affordable Corporate Cab Pune",
      "description": "Affordable Corporate Cab Pune provides cost-effective corporate transportation without compromising on safety or comfort. Clean, air-conditioned vehicles and experienced drivers make it suitable for businesses seeking budget-friendly travel solutions."
    },
    {
      "name": "Chauffeur Driven Corporate Cab",
      "description": "Chauffeur Driven Corporate Cab offers stress-free travel with professional drivers handling navigation, traffic, and scheduling. Ideal for executives and business travelers, this service ensures a smooth, reliable, and comfortable journey."
    },
    {
      "name": "Best Corporate Car Rental Pune",
      "description": "Best Corporate Car Rental Pune focuses on delivering high-quality corporate transportation with dependable vehicles and trained chauffeurs. Suitable for long-term contracts and short-term business travel, it emphasizes reliability and customer satisfaction."
    },
    {
      "name": "Pune Corporate Taxi Service",
      "description": "Pune Corporate Taxi Service provides efficient and professional taxi solutions for corporate clients. With flexible booking options and punctual service, it supports daily office travel, meetings, and intercity business trips."
    },
    {
      "name": "Business Travel Cab Pune",
      "description": "Business Travel Cab Pune is tailored for professionals requiring dependable transportation for meetings, site visits, and corporate travel. Comfortable vehicles and experienced drivers ensure timely and smooth journeys."
    },
    {
      "name": "Airport Corporate Cab Pune",
      "description": "Airport Corporate Cab Pune ensures punctual and hassle-free airport transfers for corporate travelers. With flight tracking, timely pickups, and comfortable vehicles, this service is ideal for executives and business guests."
    },
    {
      "name": "Long Term Corporate Cab Pune",
      "description": "Long Term Corporate Cab Pune offers dedicated cab solutions for companies requiring regular and extended transportation services. This option ensures cost efficiency, consistent service quality, and reliable employee mobility."
    },
    {
      "name": "Online Cab Booking Pune",
      "description": "Online Cab Booking Pune allows corporate clients to easily schedule and manage cab bookings through a convenient online platform. With instant confirmations and flexible options, it ensures smooth and efficient corporate travel planning."
    }
  ],
  "tableData": [
    ["Corporate Car Rental Services in Pune", "Corporate Cab Hire Pune"],
    ["AC Corporate Cab Pune", "Luxury Corporate Car Pune"],
    ["Office Transport Cab Pune", "Employee Transport Cab Pune"],
    ["Corporate Event Cab Pune", "Affordable Corporate Cab Pune"],
    ["Chauffeur Driven Corporate Cab", "Best Corporate Car Rental Pune"],
    ["Pune Corporate Taxi Service", "Business Travel Cab Pune"],
    ["Airport Corporate Cab Pune", "Long Term Corporate Cab Pune"],
    ["Online Cab Booking Pune", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Corporate Car Rental Services in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and professional corporate car rental services in Pune, suitable for business meetings, employee transportation, airport transfers, and corporate events."
  },
  {
    "WhyChooseheading": "Well-Maintained Corporate Vehicles",
    "WhyChoosedescription": "Our corporate fleet consists of clean, air-conditioned, and regularly serviced vehicles to ensure comfortable and hassle-free business travel."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are licensed, punctual, well-trained, and experienced in handling corporate travel requirements with professionalism."
  },
  {
    "WhyChooseheading": "Flexible Corporate Rental Packages",
    "WhyChoosedescription": "We provide hourly, daily, monthly, and long-term corporate car rental plans tailored to meet your business needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing and GST Billing",
    "WhyChoosedescription": "Sanavi Travels ensures clear pricing with GST-compliant invoices and no hidden charges for corporate clients."
  },
  {
    "WhyChooseheading": "24/7 Corporate Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to manage bookings, scheduling, and last-minute corporate travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized regularly to provide a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and reliable service, helping businesses maintain efficiency and professionalism."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide corporate car rental services in Pune?',
    answer: 'Yes, Sanavi Travels offers professional and reliable corporate car rental services in Pune.'
  },
  {
    question: 'What types of vehicles are available for corporate rentals?',
    answer: 'We offer sedans, SUVs, premium, and luxury vehicles for corporate travel.'
  },
  {
    question: 'Are monthly corporate rental packages available?',
    answer: 'Yes, we provide flexible monthly and long-term corporate car rental packages.'
  },
  {
    question: 'Do you provide GST invoices for corporate bookings?',
    answer: 'Yes, all corporate bookings include GST-compliant invoices.'
  },
  {
    question: 'Are drivers trained for corporate travel?',
    answer: 'Yes, our drivers are professional, punctual, and experienced in corporate transportation.'
  },
  {
    question: 'Is airport transfer included in corporate car rental services?',
    answer: 'Yes, we offer airport pickup and drop services for corporate clients in Pune.'
  },
  {
    question: 'Can companies customize corporate travel requirements?',
    answer: 'Absolutely. Routes, schedules, and vehicle types can be customized as per business needs.'
  },
  {
    question: 'Is the corporate car rental service available 24x7?',
    answer: 'Yes, Sanavi Travels provides 24x7 corporate car rental services.'
  },
  {
    question: 'How can a company book corporate car rental services?',
    answer: 'Bookings can be made through our website or by contacting our 24x7 customer support team.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshmukh',
    feedback: 'Sanavi Travels provides excellent corporate car rental service in Pune. Always punctual and professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Very reliable corporate travel service with clean vehicles and transparent billing.',
    rating: 5
  }
];



























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rental Services in Pune - Sanavi Travels",
  "description": "Book corporate car rentals in Pune with Sanavi Travels. AC and luxury cars for office transport, employee travel, corporate events, airport transfers, long-term rentals, and chauffeur-driven business travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};



  return (
    <div>
<Helmet>
  <title>
    Corporate Car Rental Services in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury corporate cars in Pune with Sanavi Travels. Perfect for office transport, employee travel, corporate events, airport transfers, long-term rentals, and safe chauffeur-driven business travel."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/70.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecarrentalserviceinpune;